// import React from 'react'

const Footer = () => {
  return (
    <footer>
       All Rights Reserved By : Muhammad Bilal
    </footer>
  )
}

export default Footer